import type { tableGrid } from '@w/content-blocks/src/table-html'

type Grid = ReturnType<typeof tableGrid>
interface Cell { x: number; y: number }

/**
 * The grid rectangle a table selection covers: its anchor and focus cells (top-left coordinates), each spanning its
 * rowSpan/colSpan (@lexical/table `TableSelection.getShape`).
 */
export function tableShape(grid: Grid, table: { anchor: Cell; focus: Cell }): { from: Cell; to: Cell } {
  const end = ({ x, y }: Cell) => ({ x: x + (grid[y]?.[x]?.colSpan ?? 1) - 1, y: y + (grid[y]?.[x]?.rowSpan ?? 1) - 1 })
  const [anchorEnd, focusEnd] = [end(table.anchor), end(table.focus)]
  return {
    from: { x: Math.min(table.anchor.x, table.focus.x), y: Math.min(table.anchor.y, table.focus.y) },
    to: { x: Math.max(anchorEnd.x, focusEnd.x), y: Math.max(anchorEnd.y, focusEnd.y) },
  }
}

